import React, { Component } from 'react'

import NumberFormatCustom from '../std/NumberFormatCustom';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TestVehicleDiscount extends Component {

	constructor(props) {
		super(props);
		this.state = TestVehicleDiscount.getStateFromProps(props);
		this.onChange = props.onChange;
	}
	static getStateFromProps(props) {
		return {
			code: props.data.code,
			amountInclTax: props.data.amountInclTax,
			amountExclTax: props.data.amountExclTax,
		};
	}
	static getDerivedStateFromProps(props, currentState) {
		if (currentState !== TestVehicleDiscount.getStateFromProps(props)) {
			return TestVehicleDiscount.getStateFromProps(props);
		}
		return null;
	}

	onChange = function (data) { }

	handleChange(data, name) {
		var updateVar = { ...this.state };
		updateVar[name] = data[name];
		if (updateVar.amountInclTax != null) {
			updateVar.amountInclTax = updateVar.amountInclTax * 1.0;
		}
		if (updateVar.amountExclTax != null) {
			updateVar.amountExclTax = updateVar.amountExclTax * 1.0;
		}
		this.onChange(updateVar);
	}
	handleChangeGeneric = name => event => { this.handleChange({ [name]: event.target.value }, name); };
	getLabel(fieldname, i18nKey) { return this.props.settings.isDevelopperView ? fieldname : this.getMessage(i18nKey); }
	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }


	render() {
		return (
			<React.Fragment>
				<div className="col-auto">
					<label htmlFor={`discount-${this.state.code}`} className="form-label">{this.getLabel('code', 'generics.code')}</label>
					<input id={`discount-${this.state.code}`} type="text" className="form-control"
						value={this.state.code} onChange={this.handleChangeGeneric('code')} />
				</div>
				<div className="col-auto">
					<label htmlFor={`discount-${this.state.code}-amountInclTax`} className="form-label">{this.getLabel('amountInclTax', 'generics.amountInclTax')}</label>
					<NumberFormatCustom id={`discount-${this.state.code}-amountInclTax`} className="form-control"
						value={this.state.amountInclTax} onChange={this.handleChangeGeneric('amountInclTax')} />
				</div>
				<div className="col-auto">
					<label htmlFor={`discount-${this.state.code}-amountExclTax`} className="form-label">{this.getLabel('amountExclTax', 'generics.amountExclTax')}</label>
					<NumberFormatCustom id={`discount-${this.state.code}-amountExclTax`} className="form-control"
						value={this.state.amountExclTax} onChange={this.handleChangeGeneric('amountExclTax')} />
				</div>
			</React.Fragment>
		)
	}
}

export default (TestVehicleDiscount)
